/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import NavigationItem from 'bundles/teach-partner-2018/components/NavigationItem';
import type { NavItem } from 'bundles/teach-partner-2018/constants/AnalyticsNavigationItems';

type Props = {
  navigationItems: Array<NavItem>;
};

const Navigation = ({ navigationItems }: Props) => {
  const filteredNavItems = navigationItems.filter((navigationItem) => !navigationItem?.isHidden);

  return (
    <ul
      css={{
        listStyleType: 'none',
        listStyle: 'none',
        width: 288,
        margin: 0,
        padding: 0,
      }}
    >
      {filteredNavItems.map((item: NavItem) => {
        return <NavigationItem key={item.name} {...item} />;
      })}
    </ul>
  );
};

export default Navigation;
